import { useEffect } from "react";
import { motion } from "framer-motion";
import { Check, ChevronLeft, ChevronRight, Plus, X } from "lucide-react";
import { img } from "@/lib/api";

export const Lightbox = ({ photos, index, setIndex, selected, toggle }) => {
  const photo = photos[index];

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setIndex(null);
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % photos.length);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + photos.length) % photos.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [photos.length, setIndex]);

  if (!photo) return null;
  const isSel = selected.has(photo.id);
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 z-[60] flex flex-col bg-ink/95 backdrop-blur-xl" data-testid="lightbox" data-lenis-prevent>
      <div className="flex items-center justify-between px-5 py-4">
        <span className="font-mono text-sm text-haze" data-testid="lightbox-code">{photo.code} · {index + 1}/{photos.length}</span>
        <button onClick={() => setIndex(null)} className="grid h-11 w-11 place-items-center rounded-full border border-white/15" data-testid="lightbox-close-btn" aria-label="Fechar"><X className="h-5 w-5" /></button>
      </div>
      <div className="relative flex flex-1 items-center justify-center px-4 pb-4">
        <motion.img key={photo.id} initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.35 }}
          src={img("preview", photo.id)} alt={photo.code} className="max-h-[72vh] max-w-full select-none rounded-xl object-contain" onContextMenu={(e) => e.preventDefault()} draggable={false} />
        <button onClick={() => setIndex((index - 1 + photos.length) % photos.length)} className="absolute left-3 grid h-12 w-12 place-items-center rounded-full bg-ink/70 sm:left-6" data-testid="lightbox-prev-btn" aria-label="Anterior"><ChevronLeft /></button>
        <button onClick={() => setIndex((index + 1) % photos.length)} className="absolute right-3 grid h-12 w-12 place-items-center rounded-full bg-ink/70 sm:right-6" data-testid="lightbox-next-btn" aria-label="Próxima"><ChevronRight /></button>
      </div>
      <div className="flex justify-center pb-8">
        <button onClick={() => toggle(photo.id)} data-testid="lightbox-toggle-select-btn"
          className={`inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-semibold transition-colors ${isSel ? "bg-white text-ink" : "bg-flash text-ink hover:bg-flash-2"}`}>
          {isSel ? <><Check className="h-5 w-5" /> Selecionada</> : <><Plus className="h-5 w-5" /> Selecionar esta foto</>}
        </button>
      </div>
    </motion.div>
  );
};
